import { formatFullDate, formatRelativeTime, formatShortDate } from "../utils/date";
import Tooltip from "./Tooltip";

interface TimestampProps {
  date: string | Date;
  /** Display mode: "relative" shows relative with full on hover, "full" shows full date */
  mode?: "relative" | "full" | "short";
  /** Optional prefix like "Registered" or "Installed" */
  prefix?: string;
  className?: string;
}

/**
 * Polished timestamp display with relative time and full date tooltip.
 */
export default function Timestamp({
  date,
  mode = "relative",
  prefix,
  className = "",
}: TimestampProps) {
  const d = typeof date === "string" ? new Date(date) : date;
  const fullDate = formatFullDate(d);

  let displayText: string;
  switch (mode) {
    case "full":
      displayText = fullDate;
      break;
    case "short":
      displayText = formatShortDate(d);
      break;
    case "relative":
    default:
      displayText = formatRelativeTime(d);
      break;
  }

  const content = prefix ? `${prefix} ${displayText}` : displayText;

  // For relative mode, show full date on hover
  if (mode === "relative") {
    return (
      <Tooltip content={fullDate}>
        <time dateTime={d.toISOString()} className={className}>
          {content}
        </time>
      </Tooltip>
    );
  }

  return (
    <time dateTime={d.toISOString()} className={className}>
      {content}
    </time>
  );
}
